import {FunctionalComponent } from 'preact';
import { Suspense, lazy } from 'preact/compat';
import { useSelector } from 'react-redux';

import { selectModalName } from '../../features/ui/slice';

const Patreon = lazy(() => import('../../features/ui/components/Patreon'));

// all components that render modal should be added here
const components = {
  Patreon,
};

// TODO change to portals
const ModalRoot: FunctionalComponent = () => {
  const modalName = useSelector(selectModalName);

  const Component = components[modalName];
  return (
    modalName && (
      <Suspense fallback={null}>
        <Component />
      </Suspense>
    )
  );
};

export default ModalRoot;
